export const devices = {
  xsmall: 400,
  small: 600,
  medium: 768,
  large: 1024,
  xlarge: 1280,
};
